<script setup lang="ts">
import type { NewsCategoryFragment, NewsEntryFragment, NewsThumbFragment, StaffMemberThumbFragment } from '#graphql-operations'

const route = useRoute()

const page = await useCraftEntry<NewsEntryFragment>({
  section: ['news'],
  slug: [route.params.slug as string],
})

const author = computed(() => page.newsAuthor?.[0] as StaffMemberThumbFragment)
const categories = computed(() => page.newsCategory as NewsCategoryFragment[])
const relateds = computed(() => page.news as NewsThumbFragment[])

useCraftSEO({ ...page, excerpt: page.excerptText || page.descriptionText })
useSeoMeta({ author: () => author.value?.title })
useI18nParams(page)
useArticleSchema(page)
</script>

<template>
  <div class="journal">
    <NewsHero :data="page" />
    <SectionsRenderer :sections="page.sections" />
    <NewsAuthor v-if="author" :author />
    <RelatedNews :id="page.id!" :categories :relateds />
  </div>
</template>

<style scoped>
:deep(.section.padded) {
  margin-block: calc(var(--spacing) * 8.5);

  @screen lg {
    margin-block: calc(var(--spacing) * 20);
  }
}

.journal :deep(.section.blockTextFlow + .section.blockTextFlow),
.journal :deep(.blocks:has(> .section.blockTextFlow:last-child) + .blocks > .section.blockTextFlow:first-child) {
  margin-top: calc(var(--spacing) * 6);

  @screen lg {
    margin-bottom: calc(var(--spacing) * 12);
  }
}
</style>
